module.exports = __webpack_public_path__ + "img/pk_valais.e8ca2473.png";